import React from 'react';
import { StyledWrapper } from './style';

type FadeType = {
  duration?: number;
  delay?: number;
  children: React.ReactNode;
  styles?: React.CSSProperties;
};

const Fade: React.FC<FadeType> = ({
  duration = 600,
  delay = 0,
  children,
  styles
}) => (
  <StyledWrapper
    style={{
      ...(styles || {}),
      animationDuration: `${duration}ms`,
      animationDelay: `${delay}ms`
    }}>
    {children}
  </StyledWrapper>
);

export default Fade;
